import { axiosInstance } from '../Axios';
const { createSlice } = require('@reduxjs/toolkit');

// Slice
const RegisterReducer = createSlice({
  name: 'register',
  initialState: {
    loading: false,
    success: false,
    error: null,
    userData: null,
  },
  reducers: {
    registerRequest(state) {
      state.loading = true;
      state.error = null;
    },
    registerSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.userData = action.payload;
    },
    registerFail(state, action) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    registerReset(state) {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.userData = null;
    }
  },
});

// Actions
const { actions } = RegisterReducer;
export const {
  registerRequest,
  registerSuccess,
  registerFail,
  registerReset
} = actions;

// Dispatch function
export const registerDispatch = (bodyData) => async (dispatch) => {
  try {
    dispatch(registerRequest());

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    const { data } = await axiosInstance.post(
      '/User/CompanyRegister',
      bodyData,
      config
    );


    if (data.status === 1) {
      dispatch(registerSuccess(data));
    } else {
      dispatch(registerFail(data.message || 'Registration failed.'));
    }
  } catch (error) {
    dispatch(
      registerFail(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
  }
};


export default RegisterReducer;
